module.exports = __webpack_public_path__ + "img/icon-error.736ec53a.png";